import { useTranslation } from "react-i18next";
import { ScanFace, ShieldAlert } from "lucide-react";

const STAGE_COLOR = { liveness: "text-amber-500", face_match: "text-destructive" };

export const VerifyAttemptRow = ({ row }) => {
  const { t } = useTranslation();
  const time = row.at ? new Date(row.at) : null;

  return (
    <tr data-testid={`verify-row-${row.id}`} className="border-b border-border/30">
      <td className="px-3 py-3 font-semibold">{row.employee_name || "—"}</td>
      <td className="px-3 py-3 text-muted-foreground">{row.branch_name || "—"}</td>
      <td className="px-3 py-3 font-mono text-xs" dir="ltr">
        {time ? time.toLocaleString() : "—"}
      </td>
      <td className="px-3 py-3 text-xs font-bold">{t(`check.${row.action}`)}</td>
      <td className="px-3 py-3">
        {row.success ? (
          <span className="flex items-center gap-1 text-xs font-bold text-primary">
            <ScanFace className="h-3.5 w-3.5" /> {t("verify.passed")}
          </span>
        ) : (
          <span className={`flex items-center gap-1 text-xs font-bold ${STAGE_COLOR[row.stage] || "text-destructive"}`}>
            <ShieldAlert className="h-3.5 w-3.5" /> {t(`verify.stage.${row.stage}`)}
          </span>
        )}
      </td>
      <td className="px-3 py-3 text-xs font-semibold">
        {row.success ? t("verify.ok") : t(`errors.${row.reason}`, { similarity: row.similarity })}
      </td>
      <td className="px-3 py-3 font-mono text-xs" dir="ltr">
        {row.liveness_score ? `${row.liveness_score}%` : "—"}
      </td>
      <td className="px-3 py-3 font-mono text-xs" dir="ltr">
        {row.similarity ? `${row.similarity}%` : "—"}
      </td>
    </tr>
  );
};
